import { useQuery } from '@tanstack/react-query';
import { cardsAPI } from '../api/modules/cards.module';

export const cardLookupKeys = {
  all: ['cardLookup'],
  detail: (cardId) => [...cardLookupKeys.all, cardId],
};

// Post-selection card lookup (fetch-card-lookup). Keyed by card id, so a
// late response for a previously selected card can never overwrite the
// current card's data.
export const useCardLookup = (cardId) => {
  return useQuery({
    queryKey: cardLookupKeys.detail(cardId),
    queryFn: async () => {
      const response = await cardsAPI.getLookUPCard(cardId);
      if (!response.success) {
        throw new Error(response.message);
      }
      return response.data;
    },
    enabled: !!cardId,
  });
};
